import React, { Fragment, useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { setStores, setCurrentPage, incCurrentPage, setCurrentCategory, setSearchString, setOrder, ALL_OPTICIAN, init } from '../Actions/Opticians.action';
import { translate } from '../Services/translation';
import { StoreItemView } from './store/StoreItemView';

const pagination = (pageCount, currentPageNumber, setCurrentPage) => {
    const pageNumbers = (currentPage, maxValue) => [...Array(5)]
        .map((_, index) => (currentPage - 2 + index))
        .filter((val) => (val <= maxValue && val >= 1));

    return (pageCount > 1 && <ul className="pagination">
        {currentPageNumber > 3 && <li className="pagination__item " key='pagination__item_first'>
            <div className={`pagination__link pagination__link`} onClick={() => setCurrentPage(1)}>{translate('pagination.first.label')}</div>
        </li>}
        <li className="pagination__item " key={'pagination__item' + 'Forrige'}>
            <div className={`pagination__link ${Number(currentPageNumber) === Number(1) ? 'pagination__link--disabled' : ''}`} onClick={() => setCurrentPage(currentPageNumber - 1)} >{translate('pagination.previous.label')}</div>
        </li>
        {[...pageNumbers(currentPageNumber, pageCount)].map((i) =>
            <li className="pagination__item" key={'pagination__item' + i}>
                <div onClick={() => setCurrentPage(i)} className={`pagination__link pagination__link${i === currentPageNumber ? '--current' : ''}`}>{i}</div>
            </li>
        )}
        <li className="pagination__item " key={'pagination__item' + 'Neste'}>
            <div onClick={() => setCurrentPage(currentPageNumber + 1)} className={`pagination__link ${Number(currentPageNumber) === Number(pageCount) ? 'pagination__link--disabled' : ''}`}>{translate('pagination.next.label')}</div>
        </li>
        {pageCount - currentPageNumber > 3 && <li className="pagination__item " key='pagination__item_last'>
            <div className={`pagination__link pagination__link`} onClick={() => setCurrentPage(pageCount)}>{translate('pagination.last.label')}</div>
        </li>}
    </ul>)
}

const sortingGroups = (categories, _selectedId, setSelectedId, setCurrentCategory) => {
    const selectedId = _selectedId ? _selectedId : ALL_OPTICIAN;
    const currentGroup = categories.find(({ value }) => value === selectedId);
    let displayCurrentGroupData = null;
    if (currentGroup) {
        const { name, description } = categories.find(({ value }) => value === selectedId);
        displayCurrentGroupData = <Fragment key={name}>
            <div className='store__sorting-groups-title'>{name}</div>
            <div className='store__sorting-groups-description'>{description}</div>
        </Fragment>
    }

    const setItem = (name) => {
        setSelectedId(name)
        setCurrentCategory(name);
    }
    return <>
        <div className='store__sorting-groups-wrapper'>
            {categories.map(({ name, value }) => <button className={`button ${value === selectedId ? "" : "hollow"}`} key={value} 
            onClick={() => setItem(value)}>{name}</button>)}
        </div>
        {displayCurrentGroupData}
    </>
}

const accordion = ({ setCurrentCategory, isItemsShown, setIsItemsShown, categories, selectedId, setSelectedId, subTitle, groupTitle }) => <>
    <div className='sub-title-wrapper'>
        <div className="sub-title">{subTitle}</div>
    </div>
    {categories !== "" && <div className='toggle-wrapper'>
        <div className="toggle custom-toggle" onClick={() => setIsItemsShown(prev => !prev)}>{groupTitle}<div className={`icon ${isItemsShown ? 'shown' : ''}`} /></div>
    </div> }
    {isItemsShown && categories && sortingGroups(categories, selectedId, setSelectedId, setCurrentCategory)}
</>

const categoryPage = ({ groupTitle, subTitle, isSearchPresent, isSortingPresent, setOrder, sortRef, setCurrentCategory, setCurrentPage, incCurrentPage, title, stores, sortOrderOptions, currentPageNumber, pageCount, isItemsShown, setIsItemsShown, search, categories, selectedId, setSelectedId }) => {
    return <div className="store__category-page">
        <div className="row">
            <div className="small-12 columns">
                <div className="store__header-wrapper">
                    {title && title !== '' && <h1 className="store__category-title">{title}</h1>}
                    {isSearchPresent && search()}
                </div>
                {accordion({ isItemsShown, setIsItemsShown, categories, selectedId, setSelectedId, setCurrentCategory, subTitle, groupTitle })}
                {isSortingPresent && <div className="row">
                    <div className="columns medium-3 medium-offset-9 custom-select-wrapper">
                        <select className="custom-select"
                            ref={sortRef}
                            onChange={(event) => setOrder(event.target.value)}>
                            {sortOrderOptions.map(({ order, text }) => <option key={order + text} value={order}>{text}</option>)}
                        </select>
                    </div>
                </div>}
                {stores && stores.length > 0 && <div className="row store__category-list">
                    {stores.map(({ id, ...other }) => <div className="columns small-12 medium-6 large-4 store__item-wrapper" key={id}>{StoreItemView({ id, ...other })}</div>)}
                </div>}
                {pagination(pageCount, currentPageNumber, setCurrentPage, incCurrentPage)}
            </div>
        </div>
    </div>
};

const CategoryItemViewer = (params) => {
    const model = params.storeSearchModel;
    const { title, subTitle, setSearchString, order, searchString, setCurrentPage, incCurrentPage, setCurrentCategory, setOrder, pageCount, init } = params;
    const currentPageNumber = params.currentPage;
    const isSearchPresent = params.isSearchPresent;
    const isSortingPresent = params.isSortingPresent;
    const stores = params.displayedStores;
    const [isItemsShown, setIsItemsShown] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const searchRef = useRef(null);
    const sortRef = useRef(null);
    const categories = (model && model.categories) ? model.categories : params.categories;
    const groupTitle = params.groupsTitleOverride ? params.groupsTitleOverride : params.groupTitle;

    useEffect(() => {
        if (model && model.stores) {
            init(model.stores)
        }
        setCurrentPage(1);
    }, []);

    const search = () =>
        <div className="store__category-page-search-wrapper">
            <div className='store__category-page-search'>
                <input ref={searchRef} className="store__category-page-search__input" type="search" placeholder={translate('category_viewer.search.placeholder')} autoComplete="off"
                    value={searchString} onChange={() => setSearchString(searchRef.current.value)} />
                <span className="geolocation-btn" onClick={() => setOrder('DIST')}></span>
                <span className="magnifier-btn"></span>
            </div>
        </div>

    useEffect(() => {
        if (order && sortRef && sortRef.current && sortRef.current.options) {
            sortRef.current.options.selectedIndex = sortOrderOptions.findIndex((item) => item.order === order)
        }
    }, [order]);

    const sortOrderOptions = [
        { order: 'NAME_ASC', text: 'Alfabetisk rekkefølge' },
        { order: 'NAME_DESC', text: 'i omvendt alfabetisk rekkefølge' },
        { order: 'DIST', text: 'geolokalisering' }
    ]
    return categoryPage({ groupTitle, subTitle, isSearchPresent, isSortingPresent, setOrder, sortRef, setCurrentCategory, setCurrentPage, incCurrentPage, stores, title, sortOrderOptions, pageCount, currentPageNumber, isItemsShown, setIsItemsShown, search, categories, selectedId, setSelectedId });
};

const mapDispatchToProps = dispatch => ({
    init: (currentStores) => dispatch(init(currentStores)),
    setCurrentCategory: (currentCategory) => dispatch(setCurrentCategory(currentCategory)),
    setCurrentPage: (currentPage) => dispatch(setCurrentPage(currentPage)),
    setSearchString: (nameFilter) => dispatch(setSearchString(nameFilter)),
    incCurrentPage: (currentPage) => dispatch(incCurrentPage(currentPage)),
    setOrder: (order) => dispatch(setOrder(order)),
    setStores: (stores) => dispatch(setStores(stores)),
});
const mapStateToProps = ({ opticians: { title, subTitle, groupTitle, categories, pageCount, currentStores, order, currentPage, displayedStores, searchString } }) => ({ title, subTitle, groupTitle, categories, searchString, pageCount, order, currentStores, currentPage, displayedStores });
export default connect(mapStateToProps, mapDispatchToProps)(CategoryItemViewer);